const initialState = () => {
  const sessionAuthenticationToken = sessionStorage.getItem("testerAccountAuthenticationToken");
  const localAuthenticationToken = localStorage.getItem("testerAccountAuthenticationToken");
  const authenticationToken = sessionAuthenticationToken || localAuthenticationToken;
  const recognizedDeviceToken = localStorage.getItem("rdt");

  return {
    alerts: {},
    testerAccount: {
      recognizedDeviceToken,
      authenticationToken,
      passwordResetFormErrors: {},
      notifications: {
        setup: "unknown",
        displayNextPromptAfter: null,
      },
    },
  };
};

export default initialState;
